import { gql } from 'apollo-boost'

const DELETE_USER = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id) {
      id
      name
      email
    }
  }
`

export default DELETE_USER
